function Render ( { condition, children } ) {
	if ( !condition )
		return null;

	return children;
}

export default Render;
